import { apiFetch } from '../../Util';

async function getSavedCartDiamonds(savedCartId) {
  const result = await apiFetch.index(['saved_cart', savedCartId, 'diamond']);
  return result.index;
}

export default getSavedCartDiamonds;
